import {
  defineNotificationWorkflow,
  notificationWorkflowKeyFromEnum,
} from '@app/modules/notifications/workflows/notification-workflow';
import { NotificationsSocialUploadFailedNotificationDtoWorkflowKeyEnum } from '@mi-front/api-v2';
import { defineMessage } from 'react-intl';
import { getFragmentPublishPathFromKey } from './parse-fragment-upload-key';

/**
 * Knock workflow: social upload failed.
 * Primary click opens the fragment publish page.
 */
export const socialUploadFailedWorkflow = defineNotificationWorkflow({
  key: notificationWorkflowKeyFromEnum(
    NotificationsSocialUploadFailedNotificationDtoWorkflowKeyEnum,
  ),
  category: 'social-upload',
  channels: { inApp: true, email: false },
  severity: 'error',
  preference: {
    title: defineMessage({
      id: 'notifications.preferences.workflow.socialUploadFailed.title',
      defaultMessage: 'Error al publicar',
    }),
    description: defineMessage({
      id: 'notifications.preferences.workflow.socialUploadFailed.description',
      defaultMessage: 'Cuando falla la publicación de un video en una red social',
    }),
  },
  actionUrl: (data) => getFragmentPublishPathFromKey(data.key),
});
